export const AUTO_DRAFT_STATE_KEY = 'autoDraft';
